module.exports = __webpack_public_path__ + "static/media/07.87d32c96.png";